import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../../components/Header.tsx';
import PageHeader from '../../../components/base/PageHeader.js';
import Footer from '../../../components/Footer.tsx';
import PayPalPayment from '../../../components/payments/paypalComponent.js';
import { generateHeaders, getBaseUrl, getUserToken } from '../../../utils/helpers.js'

const OrderCheckout = () => {
  const userToken = getUserToken();
  const navigate = useNavigate();
  const { orderId } = useParams();

  const [order, setOrder] = useState({});
  const [paymentProvider, setPaymentProvider] = useState(null);
  const [planCyclePrice, setPlanCyclePrice] = useState(null);

  const baseUrl = getBaseUrl();
  const headers = generateHeaders();

  // useEffect(() => {
  //   if (!userToken) {
  //     navigate("/login", { replace: true });
  //   }
  // }, [navigate, userToken]);

  // useEffect(() => {
  //   if (orderId) {
  //     fetchOrder();
  //   }
  // }, [orderId]);


  useEffect(() => {
    if (orderId) {
      fetch(`${baseUrl}/api/orders/${orderId}?fields=*`, { headers })
        .then(res => res.ok ? res.json() : Promise.reject('Failed to fetch order'))
        .then(data => {
          console.log("Order response:", data);
          setOrder(data.data || data); // 🔥 corrige estrutura da resposta
        })
        .catch(error => console.error('Error fetching order:', error));
    }
  }, [orderId]);


  // const fetchOrder = () => {
  //   fetch(`${baseUrl}/api/orders/${orderId}?fields=*`, {
  //     headers: headers
  //   })
  //     .then(res => {
  //       if (res.ok) {
  //         return res.json();
  //       }
  //       throw new Error('Failed to fetch order');
  //     })
  //     .then(data => {
  //       setOrder(data);
  //     })
  //     .catch(error => {
  //       console.error('Error fetching order:', error);
  //     });
  // };

  const handlePaymentSuccess = (data) => {
    console.log('Payment succeeded:', data);
    createPayment();
    // Handle successful payment (e.g., update order status in your database)
  };

  const handlePaymentError = (error) => {
    console.error('Payment error:', error);
    // Show error message to user
  };

  const createPayment = () => {
    const paymentData = {
      orderId: orderId
    };

    fetch(`${baseUrl}/api/payments/order`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(paymentData)
    })
      .then(res => {
        if (res.ok) {
          return res.json();
        }
        throw new Error('Failed to create payment');
      })
      .then(data => {
        console.log('Payment created:', data);
        // Optional: Redirect to success page or show success message
      })
      .catch(error => {
        console.error('Error creating payment:', error);
      });
  };

  return (
    <>
      <Header />
      {/* <PageHeader title="Checkout" text="Checkout" /> */}
      <div className="blog padding-top padding-bottom section-bg-color mt-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-8">
              <h4>Order</h4>
              <div className="row g-4">
                <div className="col-12">
                  <div className="sidebar__categorie">
                    <div className="sidebar__head">
                      <h6>Order Summary</h6>
                    </div>
                    <div className="sidebar__categorie-body">
                      <div className="sidebar__categorie-content">
                        <ul>
                          <li>
                            <p>Order Number</p>
                            <span>{order?.reference || 'N/A'}</span>
                          </li>
                          <li>
                            <p>Plan</p>
                            <span>{order?.planName || 'N/A'}</span>
                          </li>
                          <li>
                            <p>Billing Cycle</p>
                            <span>{order?.billingCycle || 'N/A'}</span>
                          </li>
                          <li>
                            <p>Payment Method</p>
                            <span>{order?.providerName || 'N/A'}</span>
                          </li>
                          <li>
                            <p>Status</p>
                            <span>{order?.status || 'N/A'}</span>
                          </li>
                          <li className="active">
                            <p>Total Amount</p>
                            <span>${order?.totalAmount || '0.00'}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-4">
              <div className="row g-4 align-items-center" style={{ marginBottom: "3.5rem" }}>
                <h4>Pay With</h4>
                {order?.totalAmount && (
                  <PayPalPayment
                    amount={order.totalAmount}
                    onSuccess={handlePaymentSuccess}
                    onError={handlePaymentError}
                  />
                )}
              </div>
            </div> */}

            <div className="col-lg-4">
              <div className="row g-4 align-items-center" style={{ marginBottom: "3.5rem" }}>

                {order.status !== "DONE" ? (
                  <>
                    <h4>Pay With:</h4>
                    <PayPalPayment
                      amount={order.totalAmount || 10}
                      onSuccess={handlePaymentSuccess}
                      onError={handlePaymentError}
                    />
                  </>
                ) : (
                  <>
                    <h4>Order Already Paid</h4>
                  </>
                )}


              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OrderCheckout;